/**
 * BudgetApprovalStatusService
 * Service for BudgetApprovalStatus lookup CRUD operations
 */
import { CrudService } from '../base/CrudService';
/** Service for BudgetApprovalStatus CRUD operations */
export class BudgetApprovalStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? BudgetApprovalStatusService.DEFAULT_SERVICE_PATH,
            basePath: BudgetApprovalStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
BudgetApprovalStatusService.DEFAULT_SERVICE_PATH = 'budgets';
BudgetApprovalStatusService.BASE_PATH = 'api/budgetapprovalstatuses';
//# sourceMappingURL=BudgetApprovalStatusService.js.map